export enum ObjectLinkTypes {
  Dependency = 1,
  Relation = 2,
}
